import React, { useState } from 'react';
import { Card, Switch, InputNumber, Button, message, Form } from 'antd';

const TrialSettings = () => {
    const [enabled, setEnabled] = useState(true);
    const [duration, setDuration] = useState(7);
    const onSave = () => {
        message.success('Trial settings saved! (mocked)');
    };
    return (
        <Card title="Trial Period Settings" style={{ maxWidth: 400, margin: '0 auto' }}>
            <Form layout="vertical">
                <Form.Item label="Enable Free Trial">
                    <Switch checked={enabled} onChange={setEnabled} />
                </Form.Item>
                <Form.Item label="Trial Duration (days)">
                    <InputNumber min={1} max={30} value={duration} onChange={v => setDuration(v ?? 1)} style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" onClick={onSave} block>Save Settings</Button>
                </Form.Item>
            </Form>
        </Card>
    );
};
export default TrialSettings; 